// extracted by mini-css-extract-plugin
export var chevron = "_kd-2";
export var dropdownItems = "_kd-0";
export var item = "_kd-1";